import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { blueTextFieldStyles } from 'assets/themes/textFieldStyles';
import { fastApiURL } from '../../utils/config';

const EnumAutocomplete = ({ name, label, selectedValue, onChange, enumTableName, multiple = true }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchEnums = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${fastApiURL}/api/catalogs/solutions-catalog/enums/${enumTableName}`);
                const result = await response.json();
                
                if (result.success && result.data) {
                    const formattedOptions = Object.entries(result.data).map(([id, label]) => ({
                        id: Number(id),
                        label: label
                    }));
                    setOptions(formattedOptions);
                }
            } catch (error) {
                console.error(`Failed to fetch enums for ${enumTableName}`, error);
            } finally {
                setLoading(false);
            }
        };

        fetchEnums();
    }, [enumTableName]);

    const selectedOptions = multiple 
        ? options.filter(opt => (selectedValue || []).includes(opt.id)) // Returns an array
        : options.find(opt => opt.id === selectedValue) || null;        // Returns a single object (or null)

    return (
        <Autocomplete
            multiple={multiple} 
            loading={loading}
            options={options}
            value={selectedOptions}
            getOptionLabel={(option) => option.label || `ID: ${option.id}`}
            onChange={(event, newValue) => {
                let formattedValue;
                if (multiple) {
                    // If multiple, send back an array of IDs: [1, 2, 3]
                    formattedValue = newValue.map((item) => item.id);
                } else {
                    // If single, send back a single integer ID: 2
                    formattedValue = newValue ? newValue.id : null;
                }

                onChange({
                    target: {
                        name: name,
                        value: formattedValue,
                    },
                });
            }}
            renderTags={multiple ? (tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                    <Chip {...getTagProps({ index })} key={option.id} label={option.label} size="small" />
                ))
            : undefined}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder="Select options"
                    sx={blueTextFieldStyles}
                />
            )}
        />
    );
};

export default EnumAutocomplete;